module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-6.be0cb424.mp3";